import React, { useContext, Fragment } from 'react';
import { withStyles, Divider, Button, Grid } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';
import IconMore from '../../../asset/img/btn_more_nor.svg';
// import IconMorePressed from "../../../asset/img/btn_more_sel.png";
import IconBadge from '../../../asset/img/ico_flag_newProd.png';

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0rem',
    zIndex: 10,
  },
  carousel: {
    width: '100%',
    height: '9rem',
  },
  listitem: {
    // width: "290px",
    padding: '0px',
    display: 'flex',
    marginBottom: '0.375rem',
  },
  card: {
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    background: theme.color.message.background_white,
    // border: "1px solid #d7d7d7",
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 0.375rem 0 0',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  moreItemList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '18.75rem',
    padding: '0rem 0rem 0rem 0.5rem',
  },
  moreItemCard: {
    width: '8.75rem',
    background: 'transparent',
    border: '0px',
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  moreItemText: {
    fontSize: theme.font.size13,
    fontWeight: 'bold',
    color: theme.color.text,
    textAlign: 'center',
    margin: '0.9375rem 0rem',
    lineHeight: '1.5rem',
  },
  thumbnail: {
    // height: "150px",
    padding: '1rem 0rem 0.5rem 0',
    background: 'none',
    border: 'none',
  },
  thumbnailImage: {
    width: 'auto',
    height: '8.75rem',
  },
  moreItemThumbnailImage: {
    width: '3.75rem',
    height: '3.75rem',
    backgroundImage: `url(${IconMore})`,
    backgroundSize: '60px',
    // "&:active": {
    //   backgroundImage: `url(${IconMorePressed})`,
    // },
  },
  info: {
    flexGrow: 1,
    padding: '0 1.25rem',
    // minHeight: "9.688rem",
  },
  infoTitle: {
    fontSize: theme.font.size16, // "15px",
    fontWeight: 'bold',
    color: theme.color.text_color.black,
    textAlign: 'left',
    letterSpacing: 'normal',
    lineHeight: '1.38',
    minHeight: '2.875rem',
    // padding: "0px 20px",
  },
  infoDescription: {
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.grey,
    textAlign: 'left',
    marginBottom: '0.7813rem',
  },
  table: {
    width: '-webkit-fill-available',
    margin: '0.75rem 0',
    padding: '0px',
  },
  tableRow: {
    borderBottom: `1px solid ${theme.color.list_divider}`,
    height: '100%',
    display: 'flex',
    alignItems: 'baseline',
  },
  label: {
    height: '100%',
    minHeight: '2rem',
    fontSize: theme.font.size13,
    fontWeight: 'normal',
    color: theme.color.text,
    textAlign: 'start',
    padding: '0rem 0.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    fontSize: theme.font.size13,
    fontWeight: 'normal',
    color: theme.color.text,
    textAlign: 'start',
    padding: '0rem 0.5rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  horizontalDivider: {
    width: '100%',
    height: '0.0625rem',
    backgroundColor: theme.color.list_divider,
  },
  external: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '2.813rem',
    borderRadius: '0rem 0rem 0.75rem 0.75rem',
    background: '#fafafa',
  },
  externalHorizontal: {
    display: 'flex',
    height: '2.8125rem',
    background: '#f7f0f0',
    flexDirection: 'column',
  },
  endBorderRadius: {
    borderRadius: '0 0 0.75rem 0.75rem',
  },
  externalButtonGrid: {
    padding: '0rem 1rem 1.25rem 1rem',
  },
  externalButtonRightPadding: {
    padding: '0 0.1563rem 0 0',
  },
  externalButtonLeftPadding: {
    padding: '0 0 0 0.1563rem',
  },
  externalButton: {
    margin: '0.1875rem 0',
    width: '100%',
    height: '2.5rem',
    color: theme.color.button.text_black,
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    flex: 1,
    letterSpacing: 'normal',
    border: 'none',
    borderRadius: '0.375rem',
    padding: 5,
    background: theme.color.button.background_grey,
    // "&:active": {
    //   background: "rgba(38, 38, 38, 0.1)",
    // },
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
  },
  externalButtonFirst: {
    color: theme.color.button.text_white,
    backgroundColor: theme.color.button.background_red,
  },
  externalButtonFirstDisabled: {
    color: theme.color.button.text_white_disable,
    backgroundColor: theme.color.button.background_red_disable,
  },
  externalButtonDisabled: {
    color: theme.color.button.text_red_disable,
    backgroundColor: theme.color.button.background_white_disable,
    border: `solid 1px #999`,
  },
  horizontalButton: {
    width: '100%',
    height: '2.8125rem',
    textAlign: 'center',
    color: '#707070',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0rem',
    backgroundColor: '#f7f7f7',
  },
  disabledButton: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  externalDivider: {
    height: '1.25rem',
    alignSelf: 'center',
    backgroundColor: theme.color.list_divider,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  buttonIcon: {
    width: '1.25rem',
    height: '1.25rem',
    marginRight: '0.25rem',
  },
  horizontalButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0.5rem 1.125rem',
  },
  horizontalButtonLabel: {
    display: 'flex',
    flexDirection: 'row',
  },
  priceRow: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  priceObs: {
    fontWeight: 'bold',
    fontSize: theme.font.size16,
    color: theme.color.message.text,
    // marginStart: "8px",
    wordBreak: 'breakWord',
    marginRight: '0.25rem',
  },
  priceObsNA: {
    color: theme.color.text_color.price_na,
  },
  priceMaster: {
    textDecoration: 'line-through',
    fontSize: theme.font.size12,
    color: theme.color.text_color.price_na,
    // marginStart: "8px",
  },
  badge: {
    position: 'absolute',
    margin: '0.75rem',
    display: 'flex',
  },
  badgeIcon: {
    height: theme.font.size35,
  },
  badgeTitle: {
    color: '#ffffff',
    position: 'absolute',
    fontSize: theme.font.size13,
    fontWeight: 'bold',
    margin: '0.3125rem 0.625rem',
  },
  badgeBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // margin: "12px"
  },
  badgeItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '1.25rem',
    borderRadius: '0.25rem',
    fontWeight: 'bold',
    fontSize: theme.font.size11,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1',
    letterSpacing: 'normal',
    margin: '0 0.25rem 0 0',
    padding: '0 0.375rem',
    width: 'max-content',
  },
  badgeItemGrey: {
    background: theme.color.badge.bg_grey,
    color: theme.color.badge.text_grey,
  },
  productCount: {
    margin: '0.75rem 1.25rem',
    border: 'none',
    // outline: 'none',
    background: 'transparent',
    textAlign: 'left',
    color: theme.color.text,
    fontSize: theme.font.size14,
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
  productCountDisabled: {
    textDecoration: 'none',
    fontWeight: 'normal',
  },
  innerDivider: {
    margin: '0px',
  },
  discountRate: {
    color: theme.color.text_color.red,
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    marginRight: '0.25rem',
    lineHeight: 1.13,
    letterSpacing: 'normal',
    // marginStart: "0.5rem",
  },
  discountRateDisable: {
    color: theme.color.text_color.price_na,
  },
  inventoryStatus: {
    borderRadius: '0.5rem',
    background: theme.color.message.background,
    color: '#ffffff',
    fontSize: theme.font.size12,
    padding: '0.25rem 0.5rem',
    margin: '0rem 0.25rem 0rem 0.5rem',
  },
});

const Card = React.forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const featureHorizontalButtons = false;
  const featureMoreItems = true;

  const handleClick = (url, action, event, button, item) => {
    if (!ref.clickAllowed()) {
      return;
    }

    if (button && button.type && button.type.toLowerCase() === 'speech') {
      context.request(context, item.link.product_name + ' ' + button.label, 'button');
    } else {
      openLink(context, action, url, event);
    }
  };

  const checkSoldOut = (item) => {
    let model_status = 'ACTIVE';
    // if (item?.sold_out === 'Y'){
    if (item?.model_status_code === 'SOLD_OUT') {
      model_status = 'SOLDOUT';
    } else if (item?.model_status_code === 'DISCONTINUED') {
      model_status = 'DISCONTINUED';
    }
    // }
    return model_status;
  };

  let cardList = data.items.map((item, key) => {
    const model_status = checkSoldOut(item);
    const isButtonOdd = item?.buttons ? item.buttons.length % 2 !== 0 : false;
    return (
      <div key={`cardList${key}`} className={classes.listitem}>
        <div className={classes.card}>
          <button
            className={classes.thumbnail}
            onClick={() => handleClick(item.link['product_link_url'], item.link['type'])}
          >
            <img
              className={classes.thumbnailImage}
              src={item.link['product_image_url']}
              alt={`${item.link['product_title']
                .replace('<sup>', '')
                .replace('</sup>', '')
                .replace('ThinQ', '씽큐')}, ${item.link['product_name']}, 상세 바로가기`}
            />
          </button>
          <div className={classes.info}>
            {/* HTML TAG가 들어간 경우 처리 */}
            <div
              className={classes.infoTitle}
              dangerouslySetInnerHTML={{ __html: item.link['product_title'] }}
              role={'text'}
            />
            <div
              className={classes.infoDescription}
              dangerouslySetInnerHTML={{ __html: item.link['product_name'] }}
            />
            <Divider
              orientation={'horizontal'}
              className={classes.innerDivider}
              component={'div'}
              disabled
            />
            {/* <button
            className={[
              classes.productCount,
              item.compatible_models_cnt === 0
                ? classes.productCountDisabled
                : "",
            ].join(" ")}
            onClick={() =>
              handleClick(item.link["compatible_model_url"], item.link["type"])
            }
            disabled={item.compatible_models_cnt === 0}
          >
            사용가능모델: 총 {item.compatible_models_cnt}개
            {item.compatible_models_cnt > 0 ? " >" : ""}
          </button> */}
            {/* <Divider
            orientation={"horizontal"}
            className={classes.innerDivider}
            component={"div"}
            disabled
          /> */}
            {item.product_price && item.product_price.product_master_price !== '0' && (
              <div className={classes.table} size="small">
                <Grid container className={classes.priceRow} key={`product_price${key}`}>
                  <Grid
                    item
                    className={`${classes.discountRate} ${
                      (model_status == 'DISCONTINUED' || model_status === 'SOLDOUT') &&
                      classes.discountRateDisable
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: item.product_price.discount_rate,
                    }}
                    aria-label={`할인율: ${item.product_price.discount_rate}`}
                    role="text"
                  />
                  <Grid
                    item
                    className={[
                      classes.priceObs,
                      (model_status == 'DISCONTINUED' || model_status === 'SOLDOUT') &&
                        classes.priceObsNA,
                    ].join(' ')}
                    dangerouslySetInnerHTML={{
                      __html: item.product_price.product_obs_price + '원',
                    }}
                    aria-label={`할인가: ${item.product_price.product_obs_price}원`}
                    role="text"
                  />
                  <Grid
                    item
                    className={classes.priceMaster}
                    dangerouslySetInnerHTML={{
                      __html: item.product_price.product_master_price + '원',
                    }}
                    aria-label={`정상가: ${item.product_price.product_master_price}원`}
                    role="text"
                  />
                  {/* {item.model_inventory_status &&
                    item.model_inventory_status.length > 0 && (
                      <Grid
                        item
                        className={classes.inventoryStatus}
                        dangerouslySetInnerHTML={{
                          __html: item.model_inventory_status,
                        }}
                        aria-label={`상태: ${item.model_inventory_status}`}
                        role="text"
                      />
                    )} */}
                </Grid>
              </div>
            )}
          </div>
          {/* <Divider
          orientation={"horizontal"}
          className={classes.horizontalDivider}
          component={"div"}
          disabled
        /> */}
          <div
            className={[
              classes.external,
              (featureHorizontalButtons === false || !('horizontal_buttons' in item)) &&
                classes.endBorderRadius,
            ].join(' ')}
          >
            <Grid className={classes.externalButtonGrid} container>
              {item.buttons.map((button, index) => {
                const totalButtonLength = item.buttons.length;
                const gridSizeFull = 12;
                const gridSizeHalf = 6;

                const gridSize =
                  isButtonOdd && totalButtonLength >= 3 && index >= totalButtonLength - 2
                    ? gridSizeHalf
                    : gridSizeFull;
                return (
                  <Grid
                    item
                    className={
                      isButtonOdd &&
                      (index > 0 && index % 2 === 1
                        ? classes.externalButtonRightPadding
                        : classes.externalButtonLeftPadding)
                    }
                    xs={gridSize}
                    key={`buttons${index}`}
                  >
                    <button
                      type="button"
                      className={[
                        classes.externalButton,
                        index === 0 && classes.externalButtonFirst,
                        (context.conversationEnd || button.parameters.enable === 'N') &&
                          (index === 0
                            ? classes.externalButtonFirstDisabled
                            : classes.externalButtonDisabled),
                      ].join(' ')}
                      disabled={
                        context.conversationEnd || button.parameters.enable === 'N'
                      }
                      disableRipple
                      onClick={() =>
                        handleClick(
                          context.userAgent.deviceType === 'mobile'
                            ? button.parameters.mobile_url
                            : button.parameters.url,
                          button.parameters.action,
                          button.event_action,
                          button,
                          item
                        )
                      }
                      aria-label={`${
                        button.parameters.action.toLowerCase() === 'external'
                          ? context.string.aria.external + ','
                          : ''
                      } ${button.label}, ${item.link['product_title']
                        .replace('<sup>', '')
                        .replace('</sup>', '')
                        .replace('ThinQ', '씽큐')}, ${item.link['product_name']}`}
                    >
                      <div className={classes.buttonContainer}>
                        <div>{button.label}</div>
                      </div>
                    </button>
                  </Grid>
                );
              })}
            </Grid>
          </div>
          {featureHorizontalButtons === true && item.horizontal_buttons && (
            <div
              className={[classes.externalHorizontal, classes.endBorderRadius].join(' ')}
            >
              {item.horizontal_buttons.map((button, index) => (
                <Fragment key={`horizontal_buttons${index}`}>
                  <Divider component={'div'} disabled />
                  <Button
                    type="button"
                    className={[
                      classes.horizontalButton,
                      classes.endBorderRadius,
                      (context.conversationEnd || button.parameters.enable === 'N') &&
                        classes.disabledButton,
                    ].join(' ')}
                    disabled={context.conversationEnd || button.parameters.enable === 'N'}
                    disableRipple
                    onClick={() =>
                      handleClick(
                        context.userAgent.deviceType === 'mobile'
                          ? button.parameters.mobile_url
                          : button.parameters.url,
                        button.parameters.action
                      )
                    }
                  >
                    <div className={classes.horizontalButtonContainer}>
                      <div className={classes.horizontalButtonLabel}>
                        {button.label === context.string.chat.moreProducts && (
                          <img
                            className={classes.buttonIcon}
                            src={IconMore}
                            alt={'IconMore'}
                          />
                        )}
                        <div>{button.label}</div>
                      </div>
                      <div>&#62;</div>
                    </div>
                  </Button>
                </Fragment>
              ))}
            </div>
          )}
          {(model_status === 'DISCONTINUED' || model_status === 'SOLDOUT') && (
            <div className={classes.badge}>
              <div className={classes.badgeBox}>
                <div className={`${classes.badgeItem} ${classes.badgeItemGrey}`}>
                  {model_status === 'SOLDOUT'
                    ? '품절'
                    : model_status === 'DISCONTINUED'
                    ? '단종'
                    : ''}
                </div>
              </div>
            </div>
            // <div className={classes.badge}>
            //   <img className={classes.badgeIcon} src={IconBadge} alt={"Badge"} />
            //   <span className={classes.badgeTitle}>{item.product_badge}</span>
            // </div>
          )}
        </div>
      </div>
    );
  });
  if (featureMoreItems && data.more_items && data.more_items.enable === 'Y') {
    let moreitem_button = (
      <div className={classes.moreItemList}>
        <button
          className={classes.moreItemCard}
          onClick={() => handleClick(data.more_items.url, data.more_items.type)}
        >
          <div className={classes.moreItemThumbnailImage} />
          <div className={classes.moreItemText}>
            {context.string.chat.moreItemHomepage.split('\n').map((content, index) => (
              <Fragment key={`moreItem${index}`}>
                <span>{content}</span>
                <br />
              </Fragment>
            ))}
          </div>
        </button>
      </div>
    );
    cardList.push(moreitem_button);
  }
  return cardList;
});

function AccessoryCard(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <>
      <div className={classes.root}>
        <Carousel
          className={classes.carousel}
          component={withStyles(styles)(Card)}
          data={data}
          ariaLabel={context.string.aria.product}
        />
      </div>
    </>
  );
}
export default withStyles(styles)(AccessoryCard);
